export default "__VITE_ASSET__C2$NKF$N__"